<template>
  <div class="orderException">
    <van-form label-width="120px">
      <van-field
        v-model="content.StateName"
        :label="$t.orderDetail.exceptionReason"
        readonly
        type="textarea"
      />

      <van-radio-group v-model="selected">
        <div class="fail-title">{{ $t.orderDetail.exceptionTitle }}</div>
        <van-cell
          v-for="(item, index) in options"
          :key="index"
          :title="item.label"
          clickable
          @click="selected = item.value"
          :icon="item.icon"
        >
          <template #right-icon>
            <van-radio :name="item.value" />
          </template>
        </van-cell>
      </van-radio-group>

      <div v-if="selected == 1">
        <div class="title" v-if="content">
          {{ $t.orderDetail.exceptionText(content.TransferDeliveryCount) }}
        </div>

        <van-field
          required
          clickable
          readonly
          :value="selectedAddress.text"
          :label="$t.orderDetail.receivingAddress"
          :placeholder="$t.orderDetail.select"
          @click="actionAddressSelection(selectedAddress)"
          type="textarea"
          rows="3"
        />
      </div>

      <div class="defaultBox">
        <div
          :class="
            selected == 1 && content.TransferDeliveryCount == 0
              ? 'disableButton'
              : 'defaultButton'
          "
          @click="onSubmit"
        >
          {{ $t.meta.confirm }}
        </div>
      </div>
    </van-form>
  </div>
</template>
<script>
import Vue from "vue";
import { RadioGroup, Radio, Cell, CellGroup, Form, Field } from "vant";
import Selection from "@/views/main/shippingAddress-selection/index.js";

Vue.use(Radio).use(RadioGroup).use(Cell).use(CellGroup).use(Form).use(Field);

export default {
  name: "orderException",
  data() {
    return {
      WB_Id: "",
      content: {},
      selected: 1,
      selectedAddress: {
        text: "",
        value: null,
      },
      options: [
        {
          value: 1,
          label: this.$t.orderDetail.eState1,
          icon: "share-o",
        },
        {
          value: 2,
          label: this.$t.orderDetail.eState2,
          icon: "logistics",
        },
      ],
    };
  },
  created() {
    const { WB_Id } = this.$route.query;
    this.WB_Id = WB_Id;
    this.getOrderDeliveryExceptionHandlingByWB_Id();
  },
  methods: {
    actionAddressSelection(selectedAddress) {
      const selection = Selection();
      selection.onSelected = (address) => {
        selectedAddress.value = address.CRId;
        selectedAddress.text =
          address.ReceivingName +
          " , " +
          address.PhoneNumber +
          " , " +
          address.ReceivingAddress;
      };
      selection.show();
    },
    getOrderDeliveryExceptionHandlingByWB_Id() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        var param = {
          WB_Id: this.WB_Id,
        };
        this.$api.order
          .getOrderDeliveryExceptionHandlingByWB_Id(param)
          .then((res) => {
            this.content = res.data;
            this.selectedAddress.value = res.data.CRId ? res.data.CRId : null;
            this.selectedAddress.text =
              res.data.ReceivingName +
              " , " +
              res.data.PhoneNumber +
              " , " +
              res.data.ReceivingAddress;
            resolve(true);
            this.$commonMethod.hideLoading();
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    onSubmit() {
      if (this.selected == 1 && this.content.TransferDeliveryCount == 0) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.orderDetail.exceptionTrim,
          type: "error",
        });
        return;
      }
      this.$commonMethod.showLoading();
      var param = {
        WB_Id: this.WB_Id,
        ExceptionHandling: this.selected,
        CRId: this.selectedAddress.value,
      };
      this.$api.order
        .saveOrderExceptionHandlingByWB_Id(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.orderException {
  .title {
    font-size: 14px;
    padding: 15px;
    color: #009ed4;
    background: #f1f1f1;
  }
  .fail-title {
    font-size: 14px;
    padding: 15px;
    color: #ff5852;
    background: #f1f1f1;
  }
  .defaultBox {
    margin: 5% auto;
    width: 80%;
    .defaultButton {
      position: relative;
      width: 100%;
      margin: 0 auto;
      border-radius: 100px;
      padding: 10px 0;
      text-align: center;
      background: linear-gradient(left, #009ed4, #5029c3);
      color: #ffffff;
      font-size: 14px;
    }
    .disableButton {
      position: relative;
      width: 100%;
      margin: 0 auto;
      border-radius: 100px;
      padding: 10px 0;
      text-align: center;
      background: gray;
      color: #ffffff;
      font-size: 14px;
    }
  }
}
</style>
